import '@babel/polyfill'
import 'mutationobserver-shim'
import Vue from 'vue'
import App from './App.vue'
import { BootstrapVue } from 'bootstrap-vue'
import VueRouter from 'vue-router'
import router from "@/router";
import Vuex from 'vuex'
import VueLazyload from 'vue-lazyload'

// FONTAWESONE: START
import '@fortawesome/fontawesome-free/css/all.css'
import '@fortawesome/fontawesome-free/js/all.js'
import i18n from './i18n'
// FONTAWESONE: END

// import jQuery from 'jquery';
// window.$ = window.jQuery = jQuery();

// BSV Plugin Registration
Vue.use(BootstrapVue)

Vue.config.productionTip = false
Vue.use(VueRouter);
Vue.use(Vuex)
Vue.use(VueLazyload, {
    preLoad: 1,
    throttleWait: 0,
    // error: 'assets/loader.svg',
    // loading: 'assets/loader.svg',
    attempt: 1
})



const store = new Vuex.Store({
    state: {
        showMobileMenu: false,
        isConfigReady: false
    },
    mutations: {
        toggleMenuState(state) {
            state.showMobileMenu = !state.showMobileMenu;
        },
        hideMobileMenu(state) {
            state.showMobileMenu = false;
        },
        configReady(state) {
            state.isConfigReady = true;
        }
    }
});

new Vue({
    router,
    store: store,
    i18n,
    render: h => h(App)
}).$mount('#app')
